import React from "react";
import { FaSearch, FaTimes } from "react-icons/fa";

import MultiCheckFilter from "../ui/MultiCheckFilter";

const inputClass =
  "min-h-10 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-900 shadow-sm outline-none transition focus:border-orange-400 focus:ring-2 focus:ring-orange-200 dark:border-white/10 dark:bg-slate-900 dark:text-white dark:focus:ring-orange-500/20";

const RepartitionFilters = ({
  filters,
  updateFilter,
  options,
  onReset,
}) => {
  return (
    <div className="w-full rounded-2xl border border-slate-200 bg-white/80 p-3 shadow-sm backdrop-blur dark:border-white/10 dark:bg-slate-900/80">
      <div className="mb-3">
        <label className="relative block">
          <FaSearch className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            value={filters.search}
            onChange={(event) => updateFilter("search", event.target.value)}
            placeholder="Rechercher nom, prénom, club ou licence"
            className={`${inputClass} pl-9`}
          />
        </label>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4 2xl:grid-cols-8">
        <select
          value={filters.repartitionStatus}
          onChange={(event) =>
            updateFilter("repartitionStatus", event.target.value)
          }
          className={inputClass}
        >
          <option value="all">Tous statuts</option>
          <option value="reparti">Répartis</option>
          <option value="nonReparti">Non répartis</option>
        </select>

        <select
          value={filters.gender}
          onChange={(event) => updateFilter("gender", event.target.value)}
          className={inputClass}
        >
          <option value="all">Tous genres</option>
          <option value="M">Masculin</option>
          <option value="F">Féminin</option>
        </select>

        <select
          value={filters.discipline}
          onChange={(event) => updateFilter("discipline", event.target.value)}
          className={inputClass}
        >
          <option value="all">Toutes disciplines</option>
          {options.disciplines.map((discipline) => (
            <option key={discipline} value={discipline}>
              {discipline}
            </option>
          ))}
        </select>

        <MultiCheckFilter
          label="Âges"
          placeholder="Toutes catégories"
          options={options.ageCategories}
          value={filters.ageCategories}
          onChange={(value) => updateFilter("ageCategories", value)}
        />

        <MultiCheckFilter
          label="Années"
          placeholder="Toutes années"
          options={options.years}
          value={filters.years}
          onChange={(value) => updateFilter("years", value)}
        />

        <MultiCheckFilter
          label="Poids"
          placeholder="Toutes cat. poids"
          options={options.weightCategories}
          value={filters.weightCategories}
          onChange={(value) => updateFilter("weightCategories", value)}
        />

        <input
          type="text"
          inputMode="decimal"
          value={filters.weightMin}
          onChange={(event) => updateFilter("weightMin", event.target.value)}
          className={inputClass}
          placeholder="Poids min"
        />

        <input
          type="text"
          inputMode="decimal"
          value={filters.weightMax}
          onChange={(event) => updateFilter("weightMax", event.target.value)}
          className={inputClass}
          placeholder="Poids max"
        />
      </div>

      <div className="mt-3 flex justify-end">
        <button
          type="button"
          onClick={onReset}
          className="inline-flex min-h-9 items-center gap-2 rounded-xl bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-700 transition hover:bg-slate-200 dark:bg-slate-800 dark:text-white dark:hover:bg-slate-700"
        >
          <FaTimes className="h-3 w-3" />
          Réinitialiser
        </button>
      </div>
    </div>
  );
};

export default RepartitionFilters;